import { createServiceRequestStore } from '../stores/NewCreateServiceRequestStore'
import { useCheckServiceForm } from './useCheckServiceForm'
import { useServiceApi } from './useSerialCheck'
import { useServiceResultsEffects } from './useServiceResultsEffects'
import { useServiceResultsHandlers } from './useServiceResultsHandlers'
import { useServiceResultsState } from './useServiceResultsState'

export const useNewServiceResultsDrawer = (serviceStore: any) => {
  // Форма
  const form = useCheckServiceForm()

  // Состояние
  const { state, setters, resetState } = useServiceResultsState(form.onReset)

  // Store
  const store = createServiceRequestStore

  // API
  const { serialResponse, serialResponseError, ...mutations } = useServiceApi(
    state.serialNum
  )

  // Эффекты
  useServiceResultsEffects({
    serialResponse,
    notifyRef: state.notifyRef,
    state,
    setters,
    form,
    store,
    resetState,
  })

  // Обработчики
  const handlers = useServiceResultsHandlers({
    state,
    setters,
    form,
    store,
    serviceStore,
    mutations,
    resetState,
  })

  const hasSerialCheckError =
    serialResponseError || serialResponse?.validationErrors

  // Дополнительные вычисляемые значения
  const showContinueBtn =
    (!store.diagnosticData?.equipmentId ||
      !!(hasSerialCheckError && state.serialNum)) &&
    !store.fromExistedRequest

  return {
    ...state,
    ...form,
    ...handlers,
    serialResponse,
    showContinueBtn,
    isPending: mutations.isPending,
    isCreating: mutations.isCreating,
    isSending: mutations.isSending,
    isLinking: mutations.isLinking,
    setOpenedAccordionIndex: setters.setOpenedAccordionIndex,
    setMode: setters.setMode,
    serialResponseError,
  }
}
